@if (!(loginService.isLoggedIn())) {
  <div class="centered">
    <p>
      {{ "components.login.message" | translate }}
    </p>
    <button mat-button (click)="login()">
      {{ "components.login.button" | translate }}
    </button>
  </div>
}
